import React from "react";
import { Table, Form, Button } from "react-bootstrap";
import { connect } from "react-redux";

import { fetchKonditionenAbsolut, setKonditionenAbsolut, resetKonditionenAbsolut } from "../reducers/konditionen-reducer";
import CONFIG from "../config";
import { console } from '../utils/functions';
import { Tooltip } from "../utils/components";
import { DeleteIcon } from "../utils/components/icons";

class ConditionsAbsolute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      kondition: {},
      labels: ['Beratershop', 'Mitarbeiter Konditionen', 'Verkauf Kundenshop', ''],
      aktiveKonditionen: null,
      isDirty: [],
      isFetching: false,
      error: null,
      invalidField: null, // New state variable
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.loadData = this.loadData.bind(this);
    this.resetToDefault = this.resetToDefault.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.aktiveKonditionen !== prevProps.aktiveKonditionen && !this.state.isFetching) {
      this.loadData(this.props.aktiveKonditionen);
    }
  }

  loadData = async (appType) => {
    if (this.state.isFetching) return;
    const shopAppType = CONFIG.getShopConfig({
      edelmetall: "edelmetall",
      sorten: "sorten"
    });
    if (!appType) appType = this.state.aktiveKonditionen || this.props.aktiveKonditionen || shopAppType;
    this.setState({ isFetching: true });
    let konditionRequestAbsolut = this.props.configStorage.getRequestData(appType + "KonditionenAbsolut");
    if (this.props.configStorage.isBLBAdmin() && !this.props.mandantStorage.isBLBAdmin()) {
      konditionRequestAbsolut.params = { gpNummer: this.props.mandantStorage.gpNummer };
    }

    let result;
    try {
      result = await this.props.dispatch(fetchKonditionenAbsolut({ requestData: konditionRequestAbsolut, appType })).unwrap();
    } catch (e) {
      console.log("k1", e);
      this.setState({ isFetching: false, error: e.message, kondition: {} });
      return;
    }

    const kondition = result.konditionenAbsolut || {};
    this.setState({
      isFetching: false,
      error: null,
      kondition: { ...kondition },
      aktiveKonditionen: appType,
      isDirty: []
    });
  };

  onChange(e) {
    const { name, value, type, checked } = e.target;
    let newValue;
    if (type === 'checkbox') {
      newValue = !checked;
    } else if (type === 'radio') {
      newValue = value === 'true';
    } else {
      newValue = value;
    }
    this.setState(prevState => ({
      kondition: {
        ...prevState.kondition,
        [name]: newValue
      },
      isDirty: prevState.isDirty.includes(name) ? prevState.isDirty : [...prevState.isDirty, name]
    }), () => {
      // Validate only for specific fields
      if (['bpVerkauf', 'maKondition', 'kuVerkauf'].includes(name)) {
        this.validate();
      }
    });
  }

  async onSubmit(e) {
    e.preventDefault();
    if (!this.validate()) {
      return;
    }
    this.setState({ isFetching: true });

    const { aktiveKonditionen, kondition } = this.state;
    const konditionRequest = this.props.configStorage.getRequestData(aktiveKonditionen + "KonditionenAbsolut");

    try {
      await this.props.dispatch(setKonditionenAbsolut({
        requestData: konditionRequest,
        absolutData: kondition,
        appType: aktiveKonditionen
      })).unwrap();
      this.setState({ isDirty: [], isFetching: false, error: null });
      if (typeof this.props.onChange === "function") {
        this.props.onChange();
      }
    } catch (err) {
      console.log("k2", err);
      this.setState({ isFetching: false, error: err.message });
    }
  }

  validate = () => {
    const { kondition } = this.state;
    const fieldsToValidate = ['bpVerkauf', 'maKondition', 'kuVerkauf'];
    const min = -99.99;
    const max = 99.99;

    for (let field of fieldsToValidate) {
      const value = parseFloat(kondition[field]);
      if (isNaN(value) || value < min || value > max) {
        this.setState({
          error: `Wert muss zwischen ${min.toString().replace(".", ",")} und ${max.toString().replace(".", ",")} liegen.`,
          invalidField: field // Store the name of the invalid field
        });
        return false;
      }
    }
    this.setState({ error: null, invalidField: null }); // Clear invalidField on success
    return true;
  };

  async resetToDefault(e) {
    const field = e.currentTarget.dataset.field;
    const fieldToEndpointMapping = {
      'bpVerkauf': 'resetEmBp',
      'maKondition': 'resetEmMa',
      'kuVerkauf': 'resetEmKu',
      'reset': 'reset'
    };

    const resetField = fieldToEndpointMapping[field];
    if (!resetField) return;

    this.setState({ isFetching: true, error: null });
    try {
      const { aktiveKonditionen } = this.state;
      const resetRequest = this.props.configStorage.getRequestData(aktiveKonditionen + "KonditionenAbsolut", "post");
      await this.props.dispatch(resetKonditionenAbsolut({ requestData: resetRequest, resetField })).unwrap();
      // Notify parent component to trigger a full data reload across all sections
      if (typeof this.props.onChange === "function") {
        this.props.onChange();
      }
    } catch (err) {
      console.log("k3", err);
      this.setState({ isFetching: false, error: err.message });
    }
  }

  render() {
    const { isFetching, error, isDirty, kondition, labels, invalidField } = this.state;
    const lastChange = this.props.konditionenStorage.getKonditionenAbsolutLastChange();
    const modifiedBy = this.props.konditionenStorage.getKonditionenAbsolutModifiedBy();
    //const readOnly = this.props.readOnly || !this.props.configStorage.isBLBAdmin();
    const readOnly = this.props.readOnly;

    if (isFetching && !Object.keys(kondition).length) {
      return <div data-testid="loading-indicator">Laden...</div>;
    }

    return (
      <>
        <style>{`
            .bordered-radio .form-check-input:not(:checked) {
              border: 1px solid blue;
              background-color: white;
              box-shadow: 0 0 0 2px blue; /* Sharp blue outline */
            }
            .bordered-radio .form-check-input:checked:not(:focus) {
              box-shadow: 0 0 0 2px blue; /* Sharp blue outline */
            }
          `}</style>      <Form onSubmit={this.onSubmit}>
          <h3>Konditionsanpassung (Absolutwerte)</h3>
          <p className="fs-6">
            Hinweis: Bitte wählen Sie aus, ob der nachfolgend erfasste Betrag bei jeder Position oder nur einmal pro Warenkorb verrechnet werden soll. Standardmäßig wird der Wert pro Position berechnet.
          </p>
          <div className="row mb-3">
            <div className="col-md-3">Verrechnung des Betrags</div>
            <div className="col-md-3">
              <Form.Check
                type="radio"
                label="Pro Position"
                name="position"
                value={true}
                checked={kondition.position === true}
                onChange={this.onChange}
                disabled={readOnly}
                id="pro-position"
                className="bordered-radio"
              />
            </div>
            <div className="col-md-3">
              <Form.Check
                type="radio"
                label="Einmal pro Warenkorb"
                name="position"
                value={false}
                checked={kondition.position === false}
                onChange={this.onChange}
                disabled={readOnly}
                id="einmal-pro-warenkorb"
                className="bordered-radio"
              />        </div>
          </div>
          <Table id={this.props.id} striped bordered responsive="sm">
            <thead>
              <tr>
                {labels.map(label => <th key={label}>{label}</th>)}
              </tr>
              {!readOnly && <tr>
                <th>
                  <Button variant="warning" size="sm" className="w-100" data-field="bpVerkauf" onClick={this.resetToDefault}>
                    zurücksetzen
                    <Tooltip>Setzt den Wert auf den Institutsspezifischen Standard zurück</Tooltip>
                  </Button>
                </th>
                <th>
                  <Button variant="warning" size="sm" className="w-100" data-field="maKondition" onClick={this.resetToDefault}>
                    zurücksetzen
                    <Tooltip>Setzt den Wert auf den Institutsspezifischen Standard zurück</Tooltip>
                  </Button>
                </th>
                <th>
                  <Button variant="warning" size="sm" className="w-100" data-field="kuVerkauf" onClick={this.resetToDefault}>
                    zurücksetzen
                    <Tooltip>Setzt den Wert auf den Institutsspezifischen Standard zurück</Tooltip>
                  </Button>
                </th>
                <th />

              </tr>}
            </thead>
            <tbody>
              <tr className="align-items-end">

                <td>
                  <Form.Control
                    type="number"
                    step="any"
                    name="bpVerkauf"
                    aria-label="Beratershop"
                    value={kondition.bpVerkauf ?? ""}
                    onChange={this.onChange}
                    readOnly={readOnly}
                    disabled={readOnly}
                    className={(readOnly ? "border-0 bg-transparent" : "") + (isDirty.includes('bpVerkauf') ? " dirty mark" : "") + (invalidField === 'bpVerkauf' ? " is-invalid" : "")}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    step="any"
                    name="maKondition"
                    data-testid="mitarbeiter-konditionen-input"
                    value={kondition.maKondition ?? ""}
                    onChange={this.onChange}
                    readOnly={readOnly}
                    disabled={readOnly}
                    className={(readOnly ? "border-0 bg-transparent" : "") + (isDirty.includes('maKondition') ? " dirty mark" : "") + (invalidField === 'maKondition' ? " is-invalid" : "")}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    step="any"
                    name="kuVerkauf"
                    data-testid="verkauf-kundenshop-input"
                    value={kondition.kuVerkauf ?? ""}
                    onChange={this.onChange}
                    readOnly={readOnly}
                    disabled={readOnly}
                    className={(readOnly ? "border-0 bg-transparent" : "") + (isDirty.includes('kuVerkauf') ? " dirty mark" : "") + (invalidField === 'kuVerkauf' ? " is-invalid" : "")}
                  />
                </td>
                <td>
                  {!kondition.default && !readOnly &&
                    <Button variant="danger" size="sm" className="w-100" data-field="reset" onClick={this.resetToDefault}>
                      <DeleteIcon />
                      <Tooltip>Setzt die Konditionen auf den Institutsspezifischen Standard zurück</Tooltip>
                    </Button>
                  }
                </td>
              </tr>
            </tbody>
          </Table>
          {lastChange && <div className="d-flex w-100 fs-6 justify-content-end">
            {modifiedBy ? <span className="me-auto">{modifiedBy}</span> : <span className="me-auto" />}
            Letzte Änderung: {lastChange}
          </div>}
          <div className="row">
            <div className="col-md-2">
              {!readOnly &&
                <Button
                  disabled={!isDirty.length || this.props.editMode || isFetching}
                  title="Diese Werte speichern"
                  variant="warning"
                  type="submit"
                >
                  {isFetching ? 'Speichern...' : 'Übernehmen'}
                </Button>
              }
            </div>
            <div className="col">
              {error ? (
                <div className="alert alert-danger fs-6 p-1">{error}</div>
              ) : (
                isDirty.length > 0 && (
                  <div className="alert alert-info fs-6 p-1">Daten sind noch nicht gespeichert. Bitte speichern Sie die Daten mit dem „Übernehmen“-Button</div>
                )
              )}
            </div>
          </div>
        </Form>
      </>
    );
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    konditionenStorage: store.konditionenStorage,
    mandantStorage: store.mandantStorage,
  };
})(ConditionsAbsolute);
